import * as React from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import StarIcon from "@mui/icons-material/Star";
import InfoModalAvaliacao from "../Componets/InfoModalAvaliacao";
import iconXsair from "../imagem/iconXsair.png";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";
import ConfirmacaoAvaliacao from "./ConfirmaçãoAvaliacao";
import { salvarAvaliacao } from "../services/api";
import ErroNaOperacao from "../modais/ErroNaOperacao";
import Textarea from "@mui/joy/Textarea";
import "./Avaliacao.css";

function Avaliacao({
  abrirModalAvaliacao,
  fecharModalAvaliacao,
  id,
  nome,
  titulo,
  emprestimo,
  devolucao,
  pontuacao,
  valorQntdEstrela,
  resenha,
  dataAvaliacao,
  atualizarPontuacao,
}) {
  const [openModalConf, setOpenModalConf] = useState(false);
  const [openModalError, setOpenModalError] = useState(false);
  const [valueQntd, setValueQntd] = useState();

  const labels = ["Péssimo", "Ruim", "Regular", "Bom", "Excelente"];
  const [value, setValue] = React.useState(null);
  const [resenhaText, setResenhaText] = React.useState("");

  React.useEffect(() => {
    setValueQntd(valorQntdEstrela);
  }, [valorQntdEstrela]);

  function openModal() {
    fecharModalAvaliacao();
    setOpenModalConf(true);
    setTimeout(() => {
      setOpenModalConf(false);
    }, 4000);
  }

  function openModalErroNaOperacao() {
    fecharModalAvaliacao();
    setOpenModalError(true);
    setTimeout(() => {
      setOpenModalError(false);
    }, 4000);
  }

  async function enviarAvaliacao() {
    try {
      await salvarAvaliacao({
        quantidadeEstrelas: value,
        resenha: resenhaText,
        idEmprestimo: id,
      });
      atualizarPontuacao();
      openModal();
    } catch (error) {
      openModalErroNaOperacao();
    }
  }

  function formatPont() {
    if (typeof pontuacao === "string") {
      return pontuacao;
    } else {
      return pontuacao + " pts";
    }
  }

  return (
    <>
      <ConfirmacaoAvaliacao
        openModalConf={openModalConf}
        setOpenModalConf={setOpenModalConf}
        fecharModal={() => setOpenModalConf(false)}
        nome={nome}
        text="Avaliação concluída!"
        tam="auto"
      />

      <ErroNaOperacao
        abrirModal={openModalError}
        fecharModal={() => setOpenModalError(false)}
        text="Tente novamente mais tarde"
      />

      {abrirModalAvaliacao && (
        <div>
          <Modal
            open={abrirModalAvaliacao}
            onClose={fecharModalAvaliacao}
            handleClose={fecharModalAvaliacao}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "var(--cor-branco)",
                width: "46.875rem",
                height: "31.25rem",
                boxShadow: 24,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                p: 3,
                borderRadius: "1.25rem",
              }}
            >
              <Box sx={{ display: "grid", gap: 4 }}>
                <Typography
                  variant="h6"
                  component="h3"
                  sx={{
                    color: "var(--cor-pretoApoio)",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontWeight: "43.75rem",
                    fontStyle: "normal",
                    fontSize: "1.5rem",
                    lineHeight: "1.5rem",
                    letterSpacing: "0.15px",
                    verticalAlign: "middle",
                  }}
                >
                  Avaliação
                </Typography>

                <img
                  src={iconXsair}
                  onClick={() => {
                    fecharModalAvaliacao();
                    setResenhaText("");
                    setValue(null);
                  }}
                  className="img_iconX_avaliacao"
                />

                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: 12,
                  }}
                >
                  <InfoModalAvaliacao title="Título" text={titulo} />
                  <InfoModalAvaliacao title="Empréstimo" text={emprestimo} />
                  <InfoModalAvaliacao title="Devolução" text={devolucao} />
                  <InfoModalAvaliacao title="Pontuação" text={formatPont()} />
                </Box>

                {dataAvaliacao !== null ? (
                  <Box
                    sx={{ display: "flex", justifyContent: "center", gap: 8 }}
                  >
                    {!dataAvaliacao && (
                      <Typography
                        sx={{
                          color: "var(--cor-pretoApoio)",
                          fontFamily: "Roboto",
                          fontWeight: "31.25rem",
                          fontStyle: "Medium",
                          fontSize: "1.0rem",
                          leadingTrim: "NONE",
                          lineHeight: "1.5rem",
                          letterSpacing: "0.009rem",
                          textAlign: "center",
                          verticalAlign: "middle",
                        }}
                      >
                        Faça sua avaliação
                      </Typography>
                    )}
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          gap: 8,
                        }}
                      >
                        {labels.map((label, index) => {
                          const starValue = index + 1;
                          return (
                            <Box
                              key={index}
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 1,
                              }}
                            >
                              <StarIcon
                                sx={{
                                  fontSize: "3.4em",
                                  color:
                                    valueQntd >= starValue
                                      ? "var(--cor-roxoEscuro)"
                                      : "var(--cor-branco)",
                                  stroke: "var(--cor-roxoEscuro)",
                                  strokeWidth: 1.2,
                                  borderRadius: "50%",
                                }}
                              />
                              <Typography
                                sx={{
                                  color: "var(--cor-pretoApoio)",
                                  fontFamily: "Inter",
                                  fontWeight: 500,
                                  fontStyle: "Medium",
                                  fontSize: "1.0rem",
                                  lineHeight: "1.5rem",
                                  letterSpacing: "0.009rem",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
                              >
                                {label}
                              </Typography>
                            </Box>
                          );
                        })}
                      </Box>
                    </Box>
                  </Box>
                ) : (
                  <Box sx={{ display: "grid", gap: 2 }}>
                    <Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          gap: 8,
                        }}
                      >
                        {labels.map((label, index) => {
                          const starValue = index + 1;
                          return (
                            <Box
                              key={starValue}
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                cursor: "pointer",
                                gap: 1,
                              }}
                              onClick={() => setValue(starValue)}
                            >
                              <StarIcon
                                sx={{
                                  fontSize: "3.4em",
                                  color:
                                    value >= starValue ? "var(--cor-roxoEscuro)" : "var(--cor-branco)",
                                  stroke: "var(--cor-roxoEscuro)",
                                  strokeWidth: 1.2,
                                  borderRadius: "50%",
                                }}
                              />
                              <Typography
                                sx={{
                                  color: "var(--cor-pretoApoio)",
                                  fontFamily: "Inter",
                                  fontWeight: 500,
                                  fontStyle: "Medium",
                                  fontSize: "1.0rem",
                                  lineHeight: "1.5rem",
                                  letterSpacing: "0.009rem",
                                  textAlign: "center",
                                  verticalAlign: "middle",
                                }}
                              >
                                {label}
                              </Typography>
                            </Box>
                          );
                        })}
                      </Box>
                    </Box>
                  </Box>
                )}

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >

                  {dataAvaliacao === null && (
                    <Typography
                      sx={{
                        color: "var(--cor-pretoApoio)",
                        fontFamily: "Inter",
                        fontWeight: 500,
                        fontStyle: "Medium",
                        fontSize: "1.0rem",
                        lineHeight: "1.5rem",
                        letterSpacing: "0.009rem",
                        textAlign: "center",
                        verticalAlign: "middle",
                      }}
                    >
                      Escreva uma resenha de no mínimo 200 caracteres e
                      conquiste +80 XP!
                    </Typography>
                  )}

                  {dataAvaliacao === null ? (
                    <FormControl
                      sx={{
                        width: "32.063rem",
                        height: "3.625rem",
                        justifyContent: "space-between",
                        opacity: 1,
                      }}
                      variant="outlined"
                    >
                      <OutlinedInput
                        id="outlined-adornment-weight"
                        placeholder="Digite aqui..."
                        value={resenhaText}
                        onChange={(e) => setResenhaText(e.target.value)}
                        onPaste={(e) => e.preventDefault()}
                        endAdornment={
                          <InputAdornment position="end">
                            <Typography
                              sx={{
                                color: "var(--cor-roxoEscuro)",
                                fontWeight: 500,
                                opacity: 1,
                              }}
                            >
                              {resenhaText.length}/1000
                            </Typography>
                          </InputAdornment>
                        }
                        sx={{
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderRadius: "20px / 0 0 15px 15px",
                          },
                          "& .MuiOutlinedInput-input::placeholder": {
                            color: "var(--cor-roxoEscuro)",
                            fontWeight: 500,
                            opacity: 1,
                          },
                        }}
                        aria-describedby="outlined-weight-helper-text"
                        inputProps={{
                          "aria-label": "weight",
                          maxLength: 1000,
                        }}
                      />
                    </FormControl>
                  ) : resenha !== "" ? (
                    <Textarea
                      readOnly
                      minRows={4}
                      maxRows={4}
                      sx={{
                        backgroundColor: "white",
                        marginTop: "0.063rem",
                        width: "85%",
                        height: "150px",
                        border: "1 solid rgba(101, 85, 143, 0.5)",
                        borderRadius: "20px / 0 0 15px 15px",
                      }}
                      value={resenha}
                    />
                  ) : (
                    <FormControl
                      sx={{
                        width: "32.063rem",
                        height: "3.625rem",
                        justifyContent: "space-between",
                        opacity: 1,
                      }}
                      variant="outlined"
                    >
                      <OutlinedInput
                        readOnly
                        id="outlined-adornment-weight"
                        placeholder="Você não escreveu uma resenha."
                        value={resenhaText}
                        onChange={(e) => setResenhaText(e.target.value)}
                        onPaste={(e) => e.preventDefault()}
                        endAdornment={
                          <InputAdornment
                            position="end"
                            readOnly
                          ></InputAdornment>
                        }
                        sx={{
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderRadius: "20px / 0 0 15px 15px",
                          },
                          "& .MuiOutlinedInput-input::placeholder": {
                            color: "rgba(101, 85, 143, 0.5)",
                            fontWeight: 500,
                            opacity: 1,
                          },
                        }}
                        aria-describedby="outlined-weight-helper-text"
                        inputProps={{
                          "aria-label": "weight",
                          maxLength: 1000,
                        }}
                      />
                    </FormControl>
                  )}

                  {dataAvaliacao === null ? (
                    <Button
                      disabled={
                        !((!resenhaText && value) || resenhaText.length >= 200)
                      }
                      onClick={() => {
                        if (
                          (!resenhaText && value) ||
                          resenhaText.length >= 200
                        ) {
                          enviarAvaliacao();
                          setResenhaText("");
                          setValue(null);
                        }
                      }}
                      sx={{
                        color: "var(--cor-branco)",
                        bgcolor:
                          !resenhaText && value
                            ? "var(--cor-roxoEscuro)"
                            : resenhaText.length >= 200
                            ? "var(--cor-roxoEscuro)"
                            : "rgba(140, 140, 140, 1)",
                        color: "var(--cor-branco)",
                        width: "12.5rem",
                        height: "2.438rem",
                        padding: "0.625rem",
                        borderRadius: "0.5rem",
                        textTransform: "none",
                      }}
                    >
                      Enviar avaliação
                    </Button>
                  ) : (
                    <Typography
                      id="modal-modal-description"
                      sx={{
                        mt: 2,
                        color: "var(--cor-preto)",
                        fontStyle: "Regular",
                        fontWeight: 400,
                        fontSize: "1.125rem",
                        lineHeight: "100%",
                        position: "absolute",
                        top: "87%",
                      }}
                    >
                      Você avaliou este livro em {""}
                      <span
                        style={{
                          fontStyle: "Medium",
                          fontWeight: 500,
                          fontSize: "1.125rem",
                          lineHeight: "100%",
                        }}
                      >
                        {dataAvaliacao}
                      </span>
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>
          </Modal>
        </div>
      )}
    </>
  );
}

export default Avaliacao;
